<div class="flex justify-between flex-wrap gap-4 small-gap items-center">
  <h1 class="font-bold text-xl" *ngIf="title">{{ title }}</h1>
  <div class="action-filter-controls flex items-center flex-wrap gap-3">
    <!-- Run/Download Button Section -->
    <ng-container *ngIf="showRunButton">
      <span class="run-btn-group flex items-center bg-primary p-0 rounded-md">
        <button
          (click)="onRunMenu()"
          class="run-text-btn px-3 h-[35px]"
          [ngClass]="showDownloadButton ? 'pl-5' : 'px-5'"
          [disabled]="disableRunButton"
        >
          {{ runText }}
        </button>
        <button
          *ngIf="showDownloadButton"
          [matMenuTriggerFor]="runMenuOptions"
          class="run-download-btn px-3 pr-5 border-l border-white rounded-none h-[35px] flex items-center justify-center"
        >
          <img
            class="run-download-icon"
            width="30"
            height="30"
            [src]="runIconPath"
            [alt]="runText"
          />
        </button>
      </span>
      <mat-menu #runMenuOptions="matMenu">
        <button
          mat-menu-item
          *ngFor="let menu of runMenu"
          class="text-base"
          (click)="onRunMenuChange(menu.value)"
        >
          {{ menu.key }}
        </button>
      </mat-menu>
    </ng-container>

    <!-- State Button Section -->
    <ng-container *ngIf="states?.length > 0">
      <button mat-button [matMenuTriggerFor]="tableStates" class="state-btn">
        {{ activeStateName }}
        <img class="ml-2.5 h-5" src="assets/icons/filter_icon.svg" alt="" />
      </button>
      <mat-menu #tableStates="matMenu">
        <ng-container *ngFor="let state of states">
          <button
            mat-menu-item
            *hasPermissions="state.perms"
            [ngClass]="{ 'active-state': state.value === activeState }"
            class="state-item-btn"
            (click)="onStateChange(state.value)"
          >
            <span> {{ state.name }}</span>
          </button>
        </ng-container>
        <!-- <button mat-menu-item *ngFor="let state of states" [ngClass]="{ 'active-state': state.value === activeState }" class="state-item-btn" (click)="onStateChange(state.value)">
                    <span> {{ state.name  }}</span>
                </button> -->
      </mat-menu>
    </ng-container>
    <!-- Search Section -->
    <app-search-ui
      [initialVal]="initialValue"
      (searchEmit)="onSearch($event)"
      *ngIf="showSearchInput"
    ></app-search-ui>
    <!-- Inline scope filters (area / branch / loan officer) projected from parent -->
    <ng-content select="[filters]"></ng-content>
    <!-- Trailing controls slot (e.g. a mobile-only New button); empty for
         existing pages so their layout is unchanged -->
    <ng-content select="[filterTrailing]"></ng-content>
    <!-- Number of Selected Row Section — desktop position, beside the search.
         Hidden below 500px, where the copy in the action row is used instead so
         the pills and Approve/Reject share one line. -->
    <div
      *ngIf="showNumOfRowSelected && numOfRowSelected > 0"
      class="summary-pills summary-pills--filters flex gap-x-2 h-[35px]"
    >
      <ng-container *ngTemplateOutlet="summaryPills"></ng-container>
    </div>
  </div>
  <!-- Action Section (Approve, Reject,...) -->
  <div *ngIf="!hideActionButtons" class="table-actions flex gap-4 items-center">
    <!-- Mobile position for the same pills: they cannot be moved with CSS alone
         because the two sit in different parents, and one outlet is rendered per
         breakpoint rather than the markup being written twice. -->
    <div
      *ngIf="showNumOfRowSelected && numOfRowSelected > 0"
      class="summary-pills summary-pills--actions flex gap-x-2 h-[35px]"
    >
      <ng-container *ngTemplateOutlet="summaryPills"></ng-container>
    </div>
    <app-action-bar-ui
      *ngIf="!showActionBar2"
      [actionButtons]="actionButtons"
      [disableActionButtons]="disableActionButtons"
      (actionEmit)="onActionTrigger($event)"
    ></app-action-bar-ui>
    <app-action-bar2-ui
      *ngIf="showActionBar2"
      [actionButtons]="actionButtons"
      [disableActionButtons]="disableActionButtons"
      (actionEmit)="onActionTrigger($event)"
    ></app-action-bar2-ui>
    <ng-content></ng-content>
  </div>
</div>

<!-- Count and total pills, rendered into whichever of the two slots above the
     breakpoint calls for. -->
<ng-template #summaryPills>
  <span class="summary-pill flex items-center bg-primary p-3 rounded-xl">
    <img src="assets/icons/tally_icon.svg" alt="" />
    &nbsp;: {{ numOfRowSelected }}
  </span>
  <!-- The exact figure, deliberately. This total is what the operator checks
       before approving, so it must not be rounded: formatMilliBilli shows one
       decimal from a million up, which made ₦2,000,000 and ₦2,045,000 both read
       "₦2.0m" — adding a row appeared to do nothing. The phone fit is handled in
       CSS instead (smaller type). -->
  <span class="summary-pill flex items-center bg-primary p-3 rounded-xl">
    <img src="assets/icons/sigma_icon.svg" alt="" />
    &nbsp;: {{ totalAmtOfRowSelected | currency }}</span
  >
</ng-template>
